<template>
  <div class="progress-bar" v-if="showBar" :style="`width:${proBar}%`"></div>
</template>

<script>
export default {
  name: "ProgressLoading",
  props: {
    init: {
      // 是否初始化的时候就开始显示Loading
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proBar: 0, // 当前进度
      showBar: false,
    };
  },
  methods: {
    /**
     * 显示加载进度条
     */
    start() {
      this.proBar = 10;
      this.showBar = true;
      const clearInt = setInterval(() => {
        if (this.proBar < 20) {
          this.proBar += Math.random(5);
        } else if (this.proBar < 60) {
          this.proBar += Math.random(3);
        } else if (this.proBar < 95) {
          this.proBar += Math.random(1);
        } else if (this.proBar >= 100) {
          clearInterval(clearInt);
        }
      }, 300);
    },
    /**
     * 加载完成
     */
    done() {
      this.proBar = 100;
      setTimeout(() => {
        this.showBar = false;
      }, 600);
    },
  },
  mounted() {
    if (this.init) {
      this.start();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.progress-bar {
  height: 3px;
  background-color: @theme-color;
  transition: all 350ms linear;
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;

  &.done {
    background-color: transparent;
  }
}
</style>
